import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import RmunitEditForm from './RmunitEditForm';
import RmunitList from './RmunitList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import RmunitListView from './RmunitListView'


export default function RmunitDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.rmunitDashboard);
  const [ rmunitId, setRmunitId] = React.useState('');
  const [reloadRmunitList, setReloadRmunitList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <RmunitEditForm 
            setReloadRmunitList={setReloadRmunitList}
            rmunitId={rmunitId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <RmunitListView 
                      setRmunitId = {setRmunitId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
